import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  IconButton,
  useToast,
  Box,
  Text,
  Heading,
  Divider,
} from "@chakra-ui/react";
import { AddIcon, CheckIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { getUserResources, setUserResources } from "../../../utils/userUtils";

function ResourcesModal({ isOpen, onClose, resources }) {
  const toast = useToast();
  // State to track added resources
  const [addedResources, setAddedResources] = useState({});

  const onAddResource = (resource) => {
    //console.log(resources)
    if (addedResources[resource.id]) {
      return;
    }
    setAddedResources((prev) => ({ ...prev, [resource.id]: true }));
    // First, fetch the current resources
    const data = getUserResources();
    // Check if resource ID already exists in the array
    if (data.resources.includes(resource.id)) {
      toast({
        title: "Resource Already Exists",
        description: "This resource is already in your customized list.",
        status: "info",
        duration: 5000,
        isClosable: true,
        position: "top",
      });
      return; // Stop further execution
    }

    // If not, append the new resource ID and send the update back to the server
    const updatedResources = [...data.resources, resource.id];
    setUserResources({ resources: updatedResources });
    toast({
      title: "Resource Added",
      description: "The resource has been successfully added to your list.",
      status: "success",
      duration: 5000,
      isClosable: true,
      position: "top",
    });
  };

  // Group resources by topic
  const groupedResources = resources.reduce((acc, resource) => {
    acc[resource.topic] = acc[resource.topic] || [];
    acc[resource.topic].push(resource);
    return acc;
  }, {});

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Resource Information</ModalHeader>
        <ModalBody>
          {Object.entries(groupedResources).map(([topic, resources], index) => (
            <div key={topic}>
              <Heading
                as="h3"
                size="lg"
                mt={index !== 0 ? 8 : 2}
                mb={4}
                color="teal.600"
              >
                {topic}
              </Heading>
              <Divider mb={4} />
              {resources.map((resource) => (
                <div
                  key={resource.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <p style={{ marginBottom: "2px" }}>{resource.label}</p>
                    <p style={{ fontSize: "12px", color: "gray" }}>
                      {resource.description}
                    </p>
                  </div>
                  {addedResources[resource.id] ? (
                    <IconButton
                      aria-label="Resource Added"
                      icon={<CheckIcon />}
                      colorScheme="green"
                      isDisabled={true}
                    />
                  ) : (
                    <IconButton
                      aria-label="Add resource"
                      icon={<AddIcon />}
                      onClick={() => onAddResource(resource)}
                      colorScheme="green"
                    />
                  )}
                </div>
              ))}
            </div>
          ))}
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ResourcesModal;
